<template style="">
  <div class="Game_a_type">

    <div class="yj-view" v-loading="loading">
        <!-- <div class="left">
            <img src="../images/表象心理旋转.png" alt="" width="380" height="230">
        </div> -->
        <div class="right">
          <h2>{{ info.GameName }}</h2>
          <label>训练描述:</label>
          <p>{{ info.Guideline }}</p>
          <div class="btn-group">
            <div class="btn-left">
                <button @click="startTest(0)" class="yj-btn">练习</button>
                <button @click="startTest(1)" class="yj-btn">正式</button>
            </div>
          </div>
        </div>
    </div>
    <el-dialog style="display: none;" :show-close="false" class="bg-black" :fullscreen="true" title="" :visible.sync="dialogVisible">
        <div class="stage" id="stage" ref="stage">
            <div class="text-center text-white ready-dot" v-if="pageShowStatus === 0">+</div>
            <div v-else-if="pageShowStatus === 1" class="d-flex flex-column justify-content-center" style="height: 100%;overflow: hidden;">
              <div style="font-size: 100px;" class="text-center ptb-5 text-white" :class="currentItem.isReverse === 1 ? 'reverse' : ''">
                <div :style="'transform: rotate(' + currentItem.rotate + 'deg)'">{{ letter }}</div>
              </div>
              <div style="text-align:center" class="text-center ptb-5 text-white ">
                <button type="button" class="yj-btn" @click="keyDown('f')">F </button>
                <button style="margin-left:50px" @click="keyDown('j')" type="button" class="yj-btn">J </button>
              </div>
            </div>
            <div v-else style="font-size: 30px;height: 100%;" class="d-flex flex-column justify-content-center text-center text-white">
              <div v-if="pageFeedbackStatus === 1">
                <p>您本次实验正的R的平均反应时为：{{ justAverageTime }}ms</p>
                <p style="font-size: 20px;">负的R平均反应时为：{{ againstAverageTime }}ms</p>
                <p style="font-size: 20px;">谢谢您的参与！</p>
              </div>
            </div>
        </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      letter: 'R',//呈现字母
      setIntervalTime: 1,//呈现时间(秒)
      onKeyStatus: true,//按键状态 true:可按 false:不可按
      responderStatus: true,//答题状态 true:抢答 false:正常答题
      isKey: 0,//是否按键 0:没按 1:按
      startTime: 0,//开始时间戳
      endTime: 0,//结束时间戳
      reportID: "",//游戏编号
      publishID: "",//发布编号
      startTimeDate: '',//开始日期时间
      endTimeDate: '',//结束日期时间
      practiceCount: 0,//练习测试次数
      officialCount: 0,//正式测试次数
      recordPracticeNum: 0,//练习页面数 用于判断是否到反馈页，如果到了反馈页后从注释点页面继续开始呈现页面
      testStatus: 0,//测试状态 0:测试 1:正式
      pageShowStatus: 0,//页面内容显示状态 0:注释点 1:游戏页 2:结果
      pageFeedbackStatus: 0,//反馈空屏状态
      randomIndex: 0,//随机下标
      justAverageTime: 0,//正的R平均反应时(不算错误与抢答)
      againstAverageTime: 0,//反的R平均反应时(不算错误与抢答)
      result: [],//结果
      currentItem: {},//当前显示对象
      resetRotateList: [],//重置旋转列表
      rotateList: [//旋转列表 rotate:旋转角度 isReverse:正反( 0是正 1是反)
        //0°正
        {
          rotate: 0,
          isReverse: 0
        },

        //0°反
        {
          rotate: 0,
          isReverse: 1
        },

        //正60°
        {
          rotate: 60,
          isReverse: 0
        },

        //反60°
        {
          rotate: 60,
          isReverse: 1
        },

        //正120°
        {
          rotate: 120,
          isReverse: 0
        },

        //反120°
        {
          rotate: 120,
          isReverse: 1
        },

        //正180°
        {
          rotate: 180,
          isReverse: 0
        },

        //反180°
        {
          rotate: 180,
          isReverse: 1
        },

        //正240°
        {
          rotate: 240,
          isReverse: 0
        },

        //反240°
        {
          rotate: 240,
          isReverse: 1
        },

        //正300°
        {
          rotate: 300,
          isReverse: 0
        },

        //反300°
        {
          rotate: 300,
          isReverse: 1
        }
      ],
      loading: false,
      info: { GameName: "表象的心理旋转", Guideline: "欢迎您参加本次实验，屏幕中央会呈现正着的R或者反着的R。有的字母会旋转后呈现，您需要判断字母R是正的还是反的，正的按f键，反的按j键。请将左手食指悬放在f键上方，右手食指悬放在j键上方。每一次结束后请立即准备下一次反应。抢答按错误记录。", ResultID1: null, TestNum1: 5, TestNum2: 24, Url1: "http://172.16.0.110:8003", Url2: "http://172.16.0.110:9004" },
      dialogVisible: false,
    }
  },
  mounted() {
    this.getApi();
  },
  methods: {
    mySignOutGame(){
      if (!!window.android) window.android.getTitle("");
      location.reload();
    },
    rand(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      var fff = date.getMilliseconds() >= 100 ? date.getMilliseconds() : date.getMilliseconds() >= 10 ? '0' + date.getMilliseconds() : '00' + date.getMilliseconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //
      var r = window.location.search.substr(1).match(reg); //
      if (r != null) return decodeURIComponent(r[2]);
      return null; //
    },
    // 获取初始数据
    getApi() {
        this.loading = false;
        this.practiceCount = 5;
        this.officialCount = 24;
        this.reportID = this.getUrlParam('UserID');//游戏编号
        this.publishID = this.getUrlParam('PublishID');//发布编号
    },
    keyDown(ISFj) {
      let that = this;
      that.onKeyStatus = false;
      that.isKey = 1;
      let obj = {};
      that.endTime = new Date().getTime();
      //抢答
      if (that.responderStatus) {
        obj.Result = '错误';
        obj.ReactionTime = 0;
        that.result.push(obj);
        return false
      }
      //正常答题
      obj.GameID = 'YJ-15';//游戏编号
      obj.ReportID = that.reportID;//报告编号
      obj.PublishID = that.publishID;//发布编号
      obj.StartTime = that.startTimeDate;//开始时间
      obj.No1 = that.result.length + 1;//序号
      obj.LetterType = that.resetRotateList[that.resetRotateList.length - 1].isReverse === 0 ? '正' : '反';//字母类型
      obj.RotationAngle = that.resetRotateList[that.resetRotateList.length - 1].rotate === 0 ? '0°' : that.resetRotateList[that.resetRotateList.length - 1].rotate === 60 ? '60°' : that.resetRotateList[that.resetRotateList.length - 1].rotate === 120 ? '120°' : that.resetRotateList[that.resetRotateList.length - 1].rotate === 180 ? '180°' : that.resetRotateList[that.resetRotateList.length - 1].rotate === 240 ? '240°' : '300°';//旋转角度
      obj.EndTime = this.formatDate(that.endTime);//结束时间
      if (that.result.length + 1 == 1) {
        obj.ReportID = obj.ReportID + "_" + that.publishID;
      }
      if (that.responderStatus === false) {
        const result = (ISFj === 'f' && that.resetRotateList[that.resetRotateList.length - 1].isReverse === 0) ? '正确' : (ISFj === 'j' && that.resetRotateList[that.resetRotateList.length - 1].isReverse === 1) ? '正确' : '错误';
        obj.Result = result;
        obj.ReactionTime = result === '正确' ? that.endTime - that.startTime : 0;
        that.result.push(obj);
      }
    },
    //测试开始
    startTest: function (status) {
      this.dialogVisible = true;
      this.testStatus = status;
      if (status === 0) this.commentsPoint();//练习
      if (status === 1) { this.pageShowStatus = 1; this.onKeyStatus = true; this.responderStatus = false; this.gameFun(); }//正式
      this.onKeyFun();
    },
    //注视点界面消失
    commentsPoint() {
      let that = this;
      that.onKeyStatus = true;
      that.responderStatus = true;
      that.startTime = new Date().getTime();
      that.startTimeDate = this.formatDate(this.startTime);
      setTimeout(function () {
        that.pageShowStatus = 1;
        that.recordPracticeNum += 1;
        that.responderStatus = false;
        that.gameFun();
      }, 1000)
    },
    //测试游戏逻辑函数
    gameFun() {
      let time = this.setIntervalTime;//字母呈现秒数
      let list = [];
      this.gamePublicFun();
      let timer = setInterval(() => {
      time--;
        if (time === 0) {
          this.onKeyStatus = false;
          this.recordPracticeNum += 1;
          //练习测试与正式测试测试次数
          if (this.testStatus === 0) this.practiceCount--;
          if (this.testStatus === 1) this.officialCount--;
          //判断正式是否按键
          if (this.testStatus === 1 && this.isKey === 0) this.leaveOutFun();
          if (this.testStatus === 1 && this.isKey === 1) this.isKey = 0;
          //判断正式如果完成了1轮12次后，切换下一轮、初始化数据,正式一共2轮24次
          if (this.testStatus === 1 && this.resetRotateList.length === 12) {
            list = this.resetRotateList;
            this.rotateList = list;
            this.resetRotateList = [];
          }
          //判断如果是练习并且练习页面数2时，从注释点页面开始呈现页面
          if (this.testStatus === 0 && this.recordPracticeNum === 2 && this.practiceCount >= 0) {
            clearInterval(timer);
            //判断是否按键
            if (this.isKey === 0) {this.leaveOutFun();}
            const resultHtml = this.result[this.result.length - 1].Result === '正确' ? '<span style="color: blue;">' + this.result[this.result.length - 1].Result + '</span>' : '<span style="color: red;">' + this.result[this.result.length - 1].Result + '</span>';
            const reactionTimeHtml = this.result[this.result.length - 1].ReactionTime !== 0 ? '<br/><p>' + '反应时为：' + this.result[this.result.length - 1].ReactionTime + 'ms' + '</p>' : '';
            let endTile = '本次结果';
            if (this.practiceCount === 0) endTile += '(练习结束)';
            this.$alert('本次反应结果为：' + resultHtml + ' !' + reactionTimeHtml, endTile, {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: action => {
                if (this.practiceCount !== 0) {
                  this.recordPracticeNum = 0;
                  this.pageShowStatus = 0;
                  this.result = [];
                  this.isKey = 0;
                  this.commentsPoint();
                } else {
                  mySignOutGame();
                }
              }
            });
            return false
          }
          //正式练习次数达到后结束游戏
          if (this.testStatus === 1 && this.officialCount === 0) {
            clearInterval(timer);
            this.resultFun();
            this.submitData();
          } else {
            this.onKeyStatus = true;
            this.responderStatus = false;
            this.gamePublicFun();
            time = this.setIntervalTime;
          }
        }
      }, 1000);
    },
    //游戏共用函数
    gamePublicFun(){
      this.startTime = new Date().getTime();
      this.startTimeDate = this.formatDate(this.startTime);
      this.randomIndex = this.rand(0, this.rotateList.length - 1);
      this.currentItem = this.rotateList[this.randomIndex];
      this.resetRotateList.push(this.currentItem);
      this.rotateList.splice(this.randomIndex, 1);
    },
    //遗漏
    leaveOutFun() {
      let obj = {};
      this.endTime = new Date().getTime();
      obj.GameID = 'YJ-15';//游戏编号
      obj.ReportID = this.reportID;//报告编号
      obj.PublishID = this.publishID;//发布编号
      obj.StartTime = this.startTimeDate;//开始时间
      obj.No1 = this.result.length + 1; //序号
      obj.LetterType = this.resetRotateList[this.resetRotateList.length - 1].isReverse === 0 ? '正' : '反'; //字母类型
      obj.RotationAngle = this.resetRotateList[this.resetRotateList.length - 1].rotate === 0 ? '0°' : this.resetRotateList[this.resetRotateList.length - 1].rotate === 60 ? '60°' : this.resetRotateList[this.resetRotateList.length - 1].rotate === 120 ? '120°' : this.resetRotateList[this.resetRotateList.length - 1].rotate === 180 ? '180°' : this.resetRotateList[this.resetRotateList.length - 1].rotate === 240 ? '240°' : '300°';//旋转角度
      obj.ReactionTime = 0;//反应时（毫秒）
      obj.EndTime = this.formatDate(this.endTime);//结束时间
      obj.Result = '未反应';//结果
      if (this.result.length + 1 == 1) {
        obj.ReportID = obj.ReportID + "_" + this.publishID;
      }
      this.result.push(obj);
    },
    /**监听键盘*f:正j:反*/
    onKeyFun() {
      let that = this;
      document.onkeyup = function (e) {
        let el = e || event || window.event || arguments.callee.caller.arguments[0];
        if ((el.key === 'f' && that.onKeyStatus) || (el.key === 'j' && that.onKeyStatus)) {
          that.keyDown(el.key);
        }
      };
    },
    //结果(计算正反平均反应时)
    resultFun() {
      let justAverageTime = 0;//正字反应时
      let justAverageNum = 0;//正字个数
      let againstAverageTime = 0;//反字反应时
      let againstAverageNum = 0;//反字个数
      for (let i = 0; i < this.result.length; i++) {
        //正的平均反应时
        if (this.result[i].LetterType === '正' && this.result[i].Result === '正确') {
          justAverageTime += this.result[i].ReactionTime;
          justAverageNum += 1;
        }
        //反的平均反应时
        if (this.result[i].LetterType === '反' && this.result[i].Result === '正确') {
          againstAverageTime += this.result[i].ReactionTime;
          againstAverageNum += 1;
        }
      }
      this.justAverageTime = justAverageTime / justAverageNum > 0 ? (justAverageTime / justAverageNum).toFixed(2) : 0;
      this.againstAverageTime = againstAverageTime / againstAverageNum > 0 ? (againstAverageTime / againstAverageNum).toFixed(2) : 0;
    },
    //数据保存
    submitData() { 
      alert("提交函数")
    }
  }
}

</script>

<style>
  .Game_a_type{width: 100%;height: 100%;}
  .reverse {transform: rotateY(180deg);}
  .el-dialog.is-fullscreen {background-color: #f5c0c0;}
  .button {width: 100px;height: 50px;line-height: 50px;border: 1px solid transparent;padding: 0 18px;background-color: #009688;color: #fff;white-space: nowrap;text-align: center;font-size: 15px;border-radius: 2px;cursor: pointer;}
</style>
